import { LSAppService } from './LSApp.service';
import { PageInfo } from './../classes/ServerPaging';

import { RequestOptions, Headers } from '@angular/http';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

import { ServerResponse } from './../classes/ServerResponse';
import { ServerCalls } from './../classes/ServerCalls';
import { LSServerService } from './LSServer.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LSApiService {
    public requestHeaders:Headers;
    //public requestHeaders:Headers = new Headers({'Accept': 'q=0.8;application/json;q=0.9','token': this.lsApp.getCurrentAuthToken() });

    constructor(private lsServer: LSServerService, private lsApp:LSAppService) { }

    /*
    updatePageHeaders(page:PageInfo = null) {
        if(page != null) {
            if(page.pageNumber==null) {
                page.pageNumber = 1;
            }
            if(page.pageSize==null) {
                page.pageSize = 10;
            }
            this.requestHeaders.delete("pageNumber");
            this.requestHeaders.delete("pageSize");
            this.requestHeaders.append("pageNumber", page.pageNumber + "");
            this.requestHeaders.append("pageSize", page.pageSize + "");
        }
    }*/

    version(): Observable<ServerResponse> {
        return this.lsServer.post(ServerCalls.version,null);
    }

    login(email:string, password:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({
            'Accept': 'q=0.8;application/json;q=0.9',
            'token':this.lsApp.getCurrentAuthToken()
        });
        //this.requestHeaders["Content-Type"] = "application/x-www-form-urlencoded";
        let body = new FormData();
        body.append('email', email);
        body.append('password', password);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.login,body, options);
    }


    getOrganizations(onlyDemo:boolean = false): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({
            'Accept': 'q=0.8;application/json;q=0.9',
            'token':this.lsApp.getCurrentAuthToken()
        });
        let body = new FormData();
        body.append('onlyDemo', (onlyDemo ? 1 : 0) + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getOrganizations, body, options);
    }

    getDemoUsers(): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({
            'Accept': 'q=0.8;application/json;q=0.9',
            'token':this.lsApp.getCurrentAuthToken()
        });
        let body = new FormData();
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getDemoUsers, body, options);
    }

    getOrganizationsForSelect(): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({
            'Accept': 'q=0.8;application/json;q=0.9',
            'token':this.lsApp.getCurrentAuthToken()
        });
        let body = new FormData();
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getOrganizationsForSelect, body, options);
    }

    getOrganizationManagersForSelect(orgId:Number, empId:Number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({
            'Accept': 'q=0.8;application/json;q=0.9',
            'token':this.lsApp.getCurrentAuthToken()
        });
        let body = new FormData();
        body.append('organizationId', orgId + "");
        body.append('employeeId', empId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getOrganizationManagersForSelect, body, options);
    }

    generateReportForDistributedSurveyBatchNumber(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateReportForDistributedSurveyBatchNumber, body, options);
    }

    generateM3PlusCorporateReportForBatchNumbers(batchNumber:string, orgId:number, manId:number, surveyId:number, year:string, optIndex:number, optValue:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumbers', batchNumber);
        body.append('orgId', orgId + "");
        body.append('manId', manId + "");
        body.append('surveyId', surveyId + "");
        body.append('year', year);
        body.append('optIndex', optIndex + "");
        body.append('optValue', optValue);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateM3PlusCorporateReportForBatchNumbers, body, options);
    }

    generateM3CorporateReportAttributeForBatchNumbers(batchNumber:string, orgId:number, attribute:string, surveyId:number, year:string, optIndex:number, optValue:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumbers', batchNumber);
        body.append('orgId', orgId + "");
        body.append('attribute', attribute);
        body.append('surveyId', surveyId + "");
        body.append('year', year);
        body.append('optIndex', optIndex + "");
        body.append('optValue', optValue);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateM3CorporateReportAttributeForBatchNumbers, body, options);
    }

    generateM3CorporateDepartmentManagerReportForBatchNumbers(batchNumber:string, orgId:number, attribute:string, surveyId:number, year:string, optIndex:number, optValue:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumbers', batchNumber);
        body.append('orgId', orgId + "");
        body.append('attribute', attribute);
        body.append('surveyId', surveyId + "");
        body.append('year', year);
        body.append('optIndex', optIndex + "");
        body.append('optValue', optValue);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateM3CorporateDepartmentManagerReportForBatchNumbers, body, options);
    }


    generateM3NewQuestionCorporateReportAttributeForBatchNumbers(batchNumber:string, orgId:number, attribute:string, surveyId:number, year:string, optIndex:number, optValue:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumbers', batchNumber);
        body.append('orgId', orgId + "");
        body.append('attribute', attribute);
        body.append('surveyId', surveyId + "");
        body.append('year', year);
        body.append('optIndex', optIndex + "");
        body.append('optValue', optValue);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateM3NewQuestionCorporateReportAttributeForBatchNumbers, body, options);
    }

    

    generateM3PlusCorporateReportAttributeForBatchNumbers(batchNumber:string, orgId:number, attribute:string, surveyId:number, year:string, optIndex:number, optValue:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumbers', batchNumber);
        body.append('orgId', orgId + "");
        body.append('attribute', attribute);
        body.append('surveyId', surveyId + "");
        body.append('year', year);
        body.append('optIndex', optIndex + "");
        body.append('optValue', optValue);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateM3PlusCorporateReportAttributeForBatchNumbers, body, options);
    }
    

    generateM3DepartmentReportForBatchNumbers(batchNumber:string, orgId:number, manId:number, surveyId:number, year:string, optIndex:number, optValue:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumbers', batchNumber);
        body.append('orgId', orgId + "");
        body.append('manId', manId + "");
        body.append('surveyId', surveyId + "");
        body.append('year', year);
        body.append('optIndex', optIndex + "");
        body.append('optValue', optValue);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateM3DepartmentReportForBatchNumbers, body, options);
    }


    generateM3NewQuestionDepartmentReportForBatchNumbers(batchNumber:string, orgId:number, manId:number, surveyId:number, year:string, optIndex:number, optValue:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumbers', batchNumber);
        body.append('orgId', orgId + "");
        body.append('manId', manId + "");
        body.append('surveyId', surveyId + "");
        body.append('year', year);
        body.append('optIndex', optIndex + "");
        body.append('optValue', optValue);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateM3NewQuestionDepartmentReportForBatchNumbers, body, options);
    }
    


    generateM3PlusDepartmentReportForBatchNumbers(batchNumber:string, orgId:number, manId:number, surveyId:number, year:string, optIndex:number, optValue:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumbers', batchNumber);
        body.append('orgId', orgId + "");
        body.append('manId', manId + "");
        body.append('surveyId', surveyId + "");
        body.append('year', year);
        body.append('optIndex', optIndex + "");
        body.append('optValue', optValue);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateM3PlusDepartmentReportForBatchNumbers, body, options);
    }
    


    generateM3CorporateReportForBatchNumbers(batchNumber:string, orgId:number, manId:number, surveyId:number, year:string, optIndex:number, optValue:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumbers', batchNumber);
        body.append('orgId', orgId + "");
        body.append('manId', manId + "");
        body.append('surveyId', surveyId + "");
        body.append('year', year);
        body.append('optIndex', optIndex + "");
        body.append('optValue', optValue);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateM3CorporateReportForBatchNumbers, body, options);
    }

    GenerateM3NewQuestionCorporateReportForBatchNumbers(batchNumber:string, orgId:number, manId:number, surveyId:number, year:string, optIndex:number, optValue:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumbers', batchNumber);
        body.append('orgId', orgId + "");
        body.append('manId', manId + "");
        body.append('surveyId', surveyId + "");
        body.append('year', year);
        body.append('optIndex', optIndex + "");
        body.append('optValue', optValue);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateM3NewQuestionCorporateReportForBatchNumbers, body, options);
    }

    generateReportForOrgInExcel(orgId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('orgId', orgId+"");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateReportForOrgInExcel, body, options);
    }


    bulkActionQueueModify(action:string, batchNumbers:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('action', action);
        body.append('batchNumbers', batchNumbers);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.bulkActionQueueModify, body, options);
    }

    viewReportForDistributedSurveyBatchNumber(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.viewReportForDistributedSurveyBatchNumber, body, options);
    }
    
    getOrganizationById(organizationId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('organizationId', organizationId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getOrganizationById, body, options);
    }

    getDepartments(organizationId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('organizationId', organizationId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getDepartments, body, options);
    }

    getEmployees(organizationId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('organizationId', organizationId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getEmployees, body, options);
    }

    getCategories(): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getCategories, null, options);
    }

    getSubCategories(): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        //body.append('categoryId', categoryId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getSubCategories, body, options);
    }

    getCategoryById(categoryId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('categoryId', categoryId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getCategoryById, body, options);
    }

    getDepartmentById(departmentId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('departmentId', departmentId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getDepartmentById, body, options);
    }

    saveDepartment(departmentId:number, name:string, organizationId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('departmentId', departmentId + "");
        body.append('name', name);
        body.append('organizationId', organizationId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.saveDepartment, body, options);
    }

    deleteDepartmentById(departmentId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('departmentId', departmentId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.deleteDepartmentById, body, options);
    }

    

    getEmployeeById(employeeId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('employeeId', employeeId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getEmployeeById, body, options);
    }


    getManagers(organizationId:number, employeeId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('organizationId', organizationId + "");
        body.append('employeeId', employeeId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getManagers, body, options);
    }

    getManagersWithEmployees(organizationId:number, employeeId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('organizationId', organizationId + "");
        body.append('employeeId', employeeId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getManagersWithEmployees, body, options);
    }
    

    saveEmployee(employeeId:number, title:string, firstname:string, lastname:string, position:string, joinedOn:string,
        email:string, passw:string, organizationId:number, managerIds:string, departmentId:number, isManager:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('employeeId', employeeId + "");
        body.append('title', title);
        body.append('firstname', firstname);
        body.append('lastname', lastname);
        body.append('position', position);
        body.append('email', email);
        body.append('passw', passw);
        body.append('joinedOn', joinedOn);
        body.append('organizationId', organizationId + "");
        body.append('managerIds', managerIds);
        body.append('departmentId', departmentId + "");
        body.append('isManager', isManager + "");
        
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.saveEmployee, body, options);
    }

    deleteEmployeeById(employeeId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('employeeId', employeeId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.deleteEmployeeById, body, options);
    }
    
    
    


    getSubCategoryById(subcategoryId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('subcategoryId', subcategoryId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getSubCategoryById, body, options);
    }


    deleteCategoryById(categoryId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('categoryId', categoryId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.deleteCategoryById, body, options);
    }



    deleteSubCategoryById(subcategoryId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('subcategoryId', subcategoryId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.deleteSubCategoryById, body, options);
    }

    saveCategory(categoryId:number, name:string, description:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('categoryId', categoryId + "");
        body.append('name', name);
        body.append('description', description);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.saveCategory, body, options);
    }

    saveSubCategory(subcategoryId:number, categoryId:number, name:string, description:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('subcategoryId', subcategoryId + "");
        body.append('categoryId', categoryId + "");
        body.append('name', name);
        body.append('description', description);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.saveSubCategory, body, options);
    }


    
    SaveOrganization(organizationId:number, legalName:string, address:string, contactPersonName:string, contactPersonPhone:string, logoFile:any): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({
            'Accept': 'q=0.8;application/json;q=0.9',
            'token':this.lsApp.getCurrentAuthToken()
        });
        this.requestHeaders.delete("Content-Type");
        //this.requestHeaders.set("Content-Type","multipart/form-data");
        let body = new FormData();
        body.append('organizationId', organizationId + "");
        body.append('legalName', legalName);
        body.append('address', address);
        body.append('contactPersonName', contactPersonName);
        body.append('contactPersonPhone', contactPersonPhone);
        if(logoFile!=null) {
            body.append("logoFile",logoFile,logoFile.name);
        }
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.saveOrganization, body, options);
    }
    

    uploadExcel(excelFile:any): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({
            'Accept': 'q=0.8;application/json;q=0.9',
            'token':this.lsApp.getCurrentAuthToken()
        });
        this.requestHeaders.delete("Content-Type");
        //this.requestHeaders.set("Content-Type","multipart/form-data");
        let body = new FormData();
        body.append("excelFile",excelFile,excelFile.name);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.uploadExcel, body, options);
    }

    
    processExcel(filename:string, logoFile:any): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({
            'Accept': 'q=0.8;application/json;q=0.9',
            'token':this.lsApp.getCurrentAuthToken()
        });
        this.requestHeaders.delete("Content-Type");
        let body = new FormData();
        body.append('filename', filename);
        if(logoFile!=null) {
            body.append("logoFile",logoFile,logoFile.name);
        }
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.processExcel, body, options);
    }

    deleteOrganization(organizationId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('organizationId', organizationId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.deleteOrganization, body, options);
    }

    getSurveys(): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        //body.append('categoryId', categoryId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getSurveys, body, options);
    }

    
    generateSurveyPreview(surveyId:number, isManager:boolean): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('surveyId', surveyId + "");
        body.append('isManager', isManager + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.generateSurveyPreview, body, options);
    }

    copyQuestions(qids:string, surveyId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('qids', qids);
        body.append('surveyId', surveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.copyQuestions, body, options);
    }
     
    saveQuestionOrder(qorders:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('qorders', qorders);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.saveQuestionOrder, body, options);
    }
    

    getSurveyById(surveyId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('surveyId', surveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getSurveyById, body, options);
    }

    addEmployeesToSurvey(employeeId:string, batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('employeeIds', employeeId);
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.addEmployeeToSurvey, body, options);
    }

    saveSurvey(surveyId:number, usePrefix:number, useFnlnOther:string, title:string, description:string, instructions:string, managerDescription:string, managerInstructions:string, defaultEmailFolder:string, defaultReportFunction:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('surveyId', surveyId + "");
        body.append('title', title);
        body.append('description', description);
        body.append('instructions', instructions);
        body.append('managerDescription', managerDescription);
        body.append('managerInstructions', managerInstructions);
        body.append('usePrefix', usePrefix + "");
        body.append('useFnlnOther', useFnlnOther);
        body.append('defaultEmailFolder', defaultEmailFolder);
        body.append('defaultReportFunction', defaultReportFunction);
        //body.append('organizationId', organizationId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.saveSurvey, body, options);
    }

    duplicateSurveybyId(surveyId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('surveyId', surveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.duplicateSurveybyId, body, options);
    }

    deleteSurveyById(surveyId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('surveyId', surveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.deleteSurveyById, body, options);
    }

    getSurveyQuestions(surveyId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('surveyId', surveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getSurveyQuestions, body, options);
    }

    getSurveyQuestionById(questionId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('questionId', questionId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getSurveyQuestionById, body, options);
    }

    saveQuestion(questionId:number, surveyId:number, questionOrder:number, title:string,managerTitle:string,
        text:string,managerText:string,positiveText:string,negativeText:string, weight:number, subCategoryId:number,
        instructions:string, type:number, minLimit:number, maxLimit:number, questionOptions:string, tips:string, groupValue:number, groupInsts:string, orderAllowed:number, allowComment:number ): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('questionId', questionId + "");
        body.append('surveyId', surveyId + "");
        body.append('title', title);
        body.append('qorder', questionOrder + "");
        body.append('text', text);
        body.append('managerTitle', managerTitle);
        body.append('managerText', managerText);
        body.append('positiveText', positiveText);
        body.append('negativeText', negativeText);
        body.append('weight', weight + "");
        body.append('subCategoryId', subCategoryId + "");
        body.append('instructions', instructions);
        body.append('type', type + "");
        body.append('maxLimit', maxLimit + "");
        body.append('minLimit', minLimit + "");
        body.append('options', questionOptions);
        body.append('tips', tips);
        body.append('groupValue', groupValue + "");
        body.append('groupInsts', groupInsts);
        body.append('orderAllowed', orderAllowed + "");
        body.append('allowComment', allowComment + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.saveQuestion, body, options);
    }

    deleteQuestionById(questionId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('questionId', questionId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.deleteQuestionById, body, options);
    }
    
/*
    getSurveysByOrganizationId(organizationId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('organizationId', organizationId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getSurveysByOrganizationId, body, options);
    }
*/



    getManagersEmployees(employeeId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('employeeId', employeeId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getManagersEmployees, body, options);
    }




    distributeSurvey(surveyId:number, usePrefix:number, useFnlnOther:string, orgId:number, managerId:number,title:string,description:string, instructions:string, defaultEmailFolder:string, defaultReportFunction:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('surveyId', surveyId + "");
        body.append('organisationId', orgId + "");
        body.append('managerId', managerId + "");
        body.append('title', title);
        body.append('description', description);
        body.append('instructions', instructions);
        body.append('usePrefix', usePrefix + "");
        body.append('useFnlnOther', useFnlnOther);
        body.append('defaultEmailFolder', defaultEmailFolder);
        body.append('defaultReportFunction', defaultReportFunction);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.distributeSurvey, body, options);
    }
    


    getDistributedSurveysBySurveyId(surveyId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('surveyId', surveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getDistributedSurveysBySurveyId, body, options);
    }

    getDistributedSurveys(orgId:number, manId:number, surveyId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('orgId', orgId + "");
        body.append('manId', manId + "");
        body.append('surveyId', surveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getDistributedSurveys, body, options);
    }

    getDistributedSurveysForCorporateReport(orgId:number, manId:number, surveyId:number, optYear:string, optValue:string, optIndex:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('orgId', orgId + "");
        body.append('manId', manId + "");
        body.append('surveyId', surveyId + "");
        body.append('year', optYear);
        body.append('optValue', optValue);
        body.append('optIndex', optIndex + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getDistributedSurveysForCorporateReport, body, options);
    }
    


    getOrganizationsForReportSelect(onlyDemo:Boolean = false): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('OnlyDemo', (onlyDemo ? 1 : 0) + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getOrganizationsForReportSelect, body, options);
    }


    getOrganizationsForCorporateReportSelect(): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        //body.append('surveyId', surveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getOrganizationsForCorporateReportSelect, body, options);
    }

    downloadDemoUsers(): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        //body.append('surveyId', surveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.downloadDemoUsers, body, options);
    }
    


    getSurveysForSelect(): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        //body.append('surveyId', surveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getSurveysForSelect, body, options);
    }

    


    getDistributedSurveyBatchNumber(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getDistributedSurveyBatchNumber, body, options);
    }

    getPendingSurveyEmployeeByBatchNumber(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getPendingSurveyEmployeeByBatchNumber, body, options);
    }

    getDashboardData(): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        //body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getDashboardData, body, options);
    }


    stopDistributedSurveysByBatchNumber(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.stopDistributedSurveysByBatchNumber, body, options);
    }

    resumeDistributedSurveysByBatchNumber(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.resumeDistributedSurveysByBatchNumber, body, options);
    }

    toggleIgnoreDistributedSurveyById(distributedSurveyId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('distributedSurveyId', distributedSurveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.toggleIgnoreDistributedSurveyById, body, options);
    }


    deleteDistributedSurveyById(distributedSurveyId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('distributedSurveyId', distributedSurveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.deleteDistributedSurveyById, body, options);
    }

    deleteDistributedSurveyByBatchNumber(batchNumber:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.deleteDistributedSurveyByBatchNumber, body, options);
    }
    


    resendSurveyLink(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.resendSurveyLink, body, options);
    }


    resendLink(batchNumber:string, employeeId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        body.append('employeeId', employeeId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.resendLink, body, options);
    }


    sendSurveyReminders(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.sendSurveyReminders, body, options);
    }


    sendReminder(batchNumber:string, employeeId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        body.append('employeeId', employeeId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.sendReminder, body, options);
    }

    resendReportEmailForBatchNumber(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.resendReportEmailForBatchNumber, body, options);
    }


    queueReportEmailForBatchNumber(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.queueReportEmailForBatchNumber, body, options);
    }

    updateTips(batchNumber:string): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('batchNumber', batchNumber);
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.updateTips, body, options);
    }


    getQueuedEmails(): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getQueuedEmails, body, options);
    }

    getQueuedEmailsForListing(orgId:number, manId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('organisationId', orgId + "");
        body.append('managerId', manId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getQueuedEmailsForListing, body, options);
    }


    getQueuedSurveysForListing(orgId:number, manId:number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('organisationId', orgId + "");
        body.append('managerId', manId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.getQueuedSurveysForListing, body, options);
    }


    manuallySendQueuedSurvey(distributedSurveyId:Number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('distributedSurveyId', distributedSurveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.manuallySendQueuedSurvey, body, options);
    }

    dontSendQueuedSurvey(distributedSurveyId:Number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('distributedSurveyId', distributedSurveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.dontSendQueuedSurvey, body, options);
    }

    addSendQueuedSurvey(distributedSurveyId:Number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('distributedSurveyId', distributedSurveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.addSendQueuedSurvey, body, options);
    }

    queueSurveyAgain(distributedSurveyId:Number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('distributedSurveyId', distributedSurveyId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.queueSurveyAgain, body, options);
    }

    






    manuallySendQueuedEmail(tipEmailId:Number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('tipEmailId', tipEmailId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.manuallySendQueuedEmail, body, options);
    }

    manuallySendQueuedEmailForceTest(tipEmailId:Number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('tipEmailId', tipEmailId + "");
        body.append('force', "1");
        body.append('test', "1");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.manuallySendQueuedEmail, body, options);
    }


    dontSendQueuedEmail(tipEmailId:Number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('tipEmailId', tipEmailId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.dontSendQueuedEmail, body, options);
    }

    addSendQueuedEmail(tipEmailId:Number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('tipEmailId', tipEmailId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.addSendQueuedEmail, body, options);
    }

    queueTipEmailAgain(tipEmailId:Number): Observable<ServerResponse> {
        let options:RequestOptions = new RequestOptions();
        this.requestHeaders = new Headers({             'Accept': 'q=0.8;application/json;q=0.9',             'token':this.lsApp.getCurrentAuthToken()         });
        let body = new FormData();
        body.append('tipEmailId', tipEmailId + "");
        options.headers = this.requestHeaders;
        return this.lsServer.post(ServerCalls.queueTipEmailAgain, body, options);
    }

    

    
    

    

    
    
    
    

    

    


    
    

    

    

    



    

    
    
    
    

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/services/LSApi.service.ts